<template>
  <transition appear>
    <div
      class="toast-notification"
      @click="$emit('onClickToast')"
    >
      <slot name="toast"></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ProaToastNotification',
  props: {
    toastNotification: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    setTimeout(() => {
      this.$emit('onTimeout')
    }, 5000)
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.v-enter-active {
  transition: all .3s ease;
}
.v-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.v-enter, .v-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.toast-notification {
  width: 100%;
  height: 66px;
  margin-bottom: 20px;
  padding: 10px;
  background-color: white;
  box-shadow: 0px 0px 8px #00000040;
  border: 1px solid $primary-color;
  border-radius: 4px;
  cursor: pointer;
  pointer-events: all;
  display: flex;
  align-items: center;
  justify-content: center;

  @include mq(md) {
    width: 310px;
  }
}
</style>
